module.exports = __webpack_public_path__ + "2a975769803b9894dc288ccc0158461e.png";